import React from 'react'
import { Button } from 'src/components/Ant'
import history from 'src/config/routes/history'
import * as Css from './styles'

interface OptionsBarProps
  extends Readonly<{
    generateCvs?: () => void
  }> {}

export default function OptionsBar({ generateCvs }: OptionsBarProps) {
  return (
    <Css.Div className="no-print">
      <Button
        onClick={() => {
          history.push('/management/reports')
        }}
        size="default"
        title="common.actions.close"
        type="danger"
      />
      <div>
        {generateCvs && (
          <Button onClick={generateCvs} size="default" title="web.csv" />
        )}
        &nbsp;
        <Button
          onClick={() => {
            window.print()
          }}
          size="default"
          title="web.report.button-print"
        />
      </div>
    </Css.Div>
  )
}
